module.exports = __webpack_public_path__ + "static/mission-bckg-fe0bad58ae7691b72e2706a02e9acb1f.jpg";